import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  CurrentUserPreferencesActions,
  CurrentUserPreferencesSelectors,
} from '@recruitee/account/data';
import {
  SupportedThemes,
  SupportedThemesT,
  Theme,
  ThemeName,
  ThemeUtilsService,
} from '@recruitee/theme';

@Injectable({ providedIn: 'root' })
export class CurrentUserPreferencesFacade {
  public activeTheme$: Observable<Theme>;
  public activeThemeName$: Observable<ThemeName>;
  public effectiveThemeName$: Observable<SupportedThemesT>;

  constructor(private store: Store) {
    this.activeTheme$ = this.store.select(CurrentUserPreferencesSelectors.data).pipe(
      ThemeUtilsService.findEffectiveThemeName,
      map(themeName => SupportedThemes[<SupportedThemesT>themeName]),
    );

    this.activeThemeName$ = <Observable<ThemeName>>(
      this.store
        .select(CurrentUserPreferencesSelectors.data)
        .pipe(map(data => data?.preferences.theme))
    );

    this.effectiveThemeName$ = this.store
      .select(CurrentUserPreferencesSelectors.data)
      .pipe(ThemeUtilsService.findEffectiveThemeName);
  }

  public setActiveTheme(themeName: ThemeName): void {
    this.store.dispatch(CurrentUserPreferencesActions.updatePreferredTheme({ payload: themeName }));
  }
}
